import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1b144cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b1b144cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b144cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b144cc')) {
      api.createRecord('b1b144cc', component.options)
    } else {
      api.reload('b1b144cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1b144cc&scoped=true", function () {
      api.rerender('b1b144cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/modelConfig/index.vue"
export default component.exports